import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Star, ArrowRight } from 'lucide-react';
import HeroSearchPill from './hero/HeroSearchPill';
import PhoneDemo from './hero/PhoneDemo';
import './HeroPhone.css';

const BOOK_DEMO_URL = 'https://portal.versalaunch.com/book-demo';
const EASE = [0.22, 0.61, 0.36, 1];

const HeroPhone = () => {
  const reduce = useReducedMotion();

  // Reading-order load-in. Each row rises a touch later than the last.
  const rise = (i) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 16 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.6, delay: 0.05 + i * 0.07, ease: EASE }
        };

  return (
    <section className="vlh-hero" aria-label="Versa Launch: get found, capture leads, automate and grow">
      <div className="hero-inner">
        <motion.p className="hero-trust" {...rise(0)}>
          <span className="hero-stars" aria-hidden="true">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
            ))}
          </span>
          Trusted by 100+ local businesses<span className="hero-trust-extra"> in Jacksonville &amp; Ponte Vedra</span>
        </motion.p>

        <motion.h1 className="vlh-title" {...rise(1)}>
          You&rsquo;re losing customers online.
          <br />
          Let us <span className="vlh-title-accent">FIX</span> it.
        </motion.h1>

        <motion.p className="hero-sub" {...rise(2)}>
          AI phone, web design, local SEO, booking &amp; reviews<span className="hero-sub-extra"> - one platform.</span>
        </motion.p>

      </div>

      <div className="hero-cta-wrap">
        <motion.div className="hero-cta" {...rise(3)}>
          <HeroSearchPill />
        </motion.div>

        <motion.p className="hero-secondary" {...rise(4)}>
          Prefer a walkthrough?{' '}
          <a href={BOOK_DEMO_URL} className="hero-secondary-link">
            Get a free demo
            <ArrowRight size={15} strokeWidth={2.4} />
          </a>
        </motion.p>
      </div>

      <motion.div
        className="hero-stage-mount"
        initial={reduce ? false : { opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: reduce ? 0 : 0.42, ease: EASE }}
      >
        <PhoneDemo />
      </motion.div>
    </section>
  );
};

export default HeroPhone;
